export async function webcamCaptureHelper(screenshotUrl, fileName, onCapture) {
  const res = await fetch(screenshotUrl);
  const blob = await res.blob();

  const file = new File([blob], fileName, {
    type: 'image/png',
  });

  onCapture(file);
}
